package com.shadowings.gero.data.lessons.chapter10

import com.shadowings.gero.data.lessons.chapter3.getGenitivoDirettoQuizContent
import com.shadowings.gero.data.lessons.chapter3.getListeNomiQuizContent
import com.shadowings.gero.data.lessons.chapter3.getRipassoGenereNumeroQuizContent
import com.shadowings.gero.data.lessons.chapter3.getVocabVarieContent
import com.shadowings.gero.data.lessons.chapter3.getVocabVarieQuizContent
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.GameConstants
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TextTranslationContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_il_genitivo_diretto_1
import gero.composeapp.generated.resources.exp_content_il_genitivo_diretto_2
import gero.composeapp.generated.resources.exp_content_il_genitivo_diretto_3
import gero.composeapp.generated.resources.exp_content_il_genitivo_diretto_4
import gero.composeapp.generated.resources.exp_content_il_genitivo_diretto_5
import gero.composeapp.generated.resources.exp_content_il_genitivo_diretto_6
import gero.composeapp.generated.resources.exp_title_il_genitivo_diretto

fun getIlGenitivoDirettoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_il_genitivo_diretto,
            content = Res.string.exp_content_il_genitivo_diretto_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_genitivo_diretto,
            content = Res.string.exp_content_il_genitivo_diretto_2,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_genitivo_diretto,
            content = Res.string.exp_content_il_genitivo_diretto_3,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_genitivo_diretto,
            content = Res.string.exp_content_il_genitivo_diretto_4,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_genitivo_diretto,
            content = Res.string.exp_content_il_genitivo_diretto_5,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_genitivo_diretto,
            content = Res.string.exp_content_il_genitivo_diretto_6,
            face = Faces.Doubt,
            character = Characters.Zeta,
        )
    )
}

fun getIlGenitivoDirettoQuizContent(
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val baseQuizzes = (
        getRipassoGenereNumeroQuizContent(words, languageCode).take(2)
            + getGenitivoDirettoQuizContent(words, languageCode).take(2)
            + getListeNomiQuizContent(words, languageCode).take(2)
            + getVocabVarieQuizContent(
                getVocabVarieContent(words, languageCode),
                words,
                languageCode
            ).take(4)
    ).shuffled().take(GameConstants.QUIZ_QUESTIONS_COUNT)

    val targetWordIds = listOf(
        "ORZO",
        "DATTERO",
        "VIPERA",
        "LEONE",
        "RE_DEL_BASSO_EGITTO",
        "APICOLTORE"
    )
    val targetWords = targetWordIds.mapNotNull { targetId -> words.firstOrNull { it.id == targetId } }
        .shuffled()
        .take(4)

    val keyboardQuizzes = targetWords.map { word ->
        TextTranslationContent(
            hieroglyphs = word.gardiner,
            correctPhrase = word.getMeaning(languageCode),
            transliteration = word.reading
        )
    }

    return baseQuizzes + keyboardQuizzes
}
